export default __webpack_public_path__ + "static/media/Hindsight.03bf2d05.md";